import React, {useEffect, useReducer, useState} from 'react'
import {BrowserRouter} from 'react-router-dom'

import requestHandler from 'utils/requestHandler'
import {logInUser} from 'utils/user'
import {usersService} from 'services'
import UserContext from 'components/User/UserContext'
import CartContext, {cartReducer, defaultCart} from 'components/Cart/CartContext'
import Loader from 'components/Loader'

const GlobalContexts = ({children}) => {
  const [user, setUser] = useState(null)
  const [cartVisible, setCartVisible] = useState(false)
  const [cartState, cartDispatch] = useReducer(
    cartReducer,
    localStorage.getItem('cart') ? {items: JSON.parse(localStorage.getItem('cart'))} : defaultCart)
  const [loading, setLoading] = useState(true)

  const tokenRefresher = () => {
    const user = JSON.parse(localStorage.getItem('user'))
    if (user) {
      usersService.authRefresh({username: user.email, refreshToken: user.refreshToken})
        .then(r => r.ok ? r.json() : r)
        .then(response => {
          if (response.success) logInUser(response, setUser)
          setLoading(false)
        })
    } else {
      setLoading(false)
    }
  }

  useEffect(() => {
    tokenRefresher()
    requestHandler.tokenRefresher = tokenRefresher
  }, [])

  return (
    <BrowserRouter basename='/buildiroShop/#/'>
      <UserContext.Provider value={{user, setUser}}>
        <CartContext.Provider value={{cart: cartState, cartDispatch, cartVisible, setCartVisible}}>
          {loading ? <Loader/> : children}
        </CartContext.Provider>
      </UserContext.Provider>
    </BrowserRouter>
  )
}

export default GlobalContexts
